import gullFrameworkMultiFactorAuthCheck from '../Framework/MultiFactorAuth/check.js';
import gullFrameworkAuthSelectuserid from '../Framework/Auth/selectUserId.js';
import gullFrameworkAuthLoginforward from '../Framework/Auth/loginForward.js';
import gullFrameworkVoorwaardenCheck from '../Framework/Voorwaarden/check.js';
import gullFrameworkUsersChangesettings from '../Framework/Users/changeSettings.js';
import gullFrameworkUsersEditView from '../Framework/Users/editView.js';
import gullFrameworkLoginTotp from '../Framework/Login/totp.js';
// import gullFrameworkLoginactivatePreGeneratedAccount from './routes/Gull/Framework/Login/activatePreGeneratedAccount.js';

const routeFunctions = {
	gullFrameworkMultiFactorAuthCheck,
	gullFrameworkAuthSelectuserid,
	gullFrameworkAuthLoginforward,
	gullFrameworkVoorwaardenCheck,
	gullFrameworkUsersChangesettings,
	gullFrameworkUsersEditView,
	gullFrameworkLoginTotp,
	// gullFrameworkLoginactivatePreGeneratedAccount,
};

export default routeFunctions;
